import { render, staticRenderFns } from "./OfferedAccessory.vue?vue&type=template&id=538d35c8&"
import script from "./OfferedAccessory.vue?vue&type=script&lang=js&"
export * from "./OfferedAccessory.vue?vue&type=script&lang=js&"
import style0 from "./OfferedAccessory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports